/* eslint-disable no-param-reassign */
import { BOEScenario } from 'views/DealDashboard/BOE/types';

interface IHighlightedBOEScenario extends BOEScenario {
    cellClasses?: Record<string, string>;
}

type Criteria = Record<string, 'greatest' | 'least'>;

export function highlightFields(
    boeScenarios: IHighlightedBOEScenario[],
    criteria: Criteria,
): IHighlightedBOEScenario[] {
    if (boeScenarios.length < 2) return boeScenarios;

    const targetValues: Record<string, number | undefined> = {};

    Object.entries(criteria).forEach(([field, type]) => {
        const values = boeScenarios
            .map(item => parseFloat(String(item[field as keyof IHighlightedBOEScenario] ?? '')))
            .filter(value => !Number.isNaN(value));

        if (values.length === 0) {
            targetValues[field] = undefined;
            return;
        }

        targetValues[field] = type === 'least' ? Math.min(...values) : Math.max(...values);
    });

    boeScenarios.forEach(item => {
        Object.keys(criteria).forEach(field => {
            if (!item.cellClasses) item.cellClasses = {};
            const value = parseFloat(String(item[field as keyof IHighlightedBOEScenario] ?? ''));
            if (
                value === targetValues[field]
                && !Number.isNaN(value)
                && targetValues[field] !== undefined
            ) {
                item.cellClasses[field] = 'green-highlight';
            } else {
                delete item.cellClasses[field];
            }
        });
    });

    return boeScenarios;
}
